// extracted by mini-css-extract-plugin
export default {"loginSignupHeader":"login_loginSignupHeader__VdUkC","loginForm":"login_loginForm__c9bti","field":"login_field__Enl9L"};